// extracted by mini-css-extract-plugin
module.exports = {"AdminHome":"Home_AdminHome__3hxhd","Tabs":"Home_Tabs__2P8IR","Img":"Home_Img__2MZ8a","Name":"Home_Name__fBC7n","Title":"Home_Title__m7aCV"};